<template>
    <div>
        <!-- TODO: there is no background color behind the two buttons -->
        <v-col v-if="allnoneButtons" cols="12" class="py-2">
            <v-btn color='orange' value="left" @click="selectAll()">
                <v-icon>mdi-playlist-check</v-icon>
                <span class="hidden-sm-and-down">{{ language.t('LayerSwitcher.all') }}</span>
            </v-btn>

            <v-btn color='orange' value="right" @click="selectNone()">
                <v-icon>mdi-playlist-remove</v-icon>
                <span>{{ language.t('LayerSwitcher.none') }}</span>
            </v-btn>
        </v-col>
        <v-list ref="layerselectorlist" class="overflow-y-auto" max-height="500">
            <v-treeview ref="treeview" v-if="layersWithNames.length > 0" :items="layersWithNames"
                v-model="selectedLayers" selectable style="v-treeview-custom" return-object on-icon="mdi-eye-outline"
                off-icon="mdi-eye-remove-outline" indeterminate-icon="mdi-eye-minus-outline" :active.sync="activeLayer">
                <template v-slot:prepend="props">
                    <v-checkbox class="pa-0 ma-0" hide-details dense v-model="props.item.checkBoxValue"
                        @click="$emit('selectLayerForEdit', props.item)" v-if="selection && props.item.actions" />

                    <v-icon v-if="selection && props.item.editButton" @click="editButtonClick(props.item)">
                        mdi-pencil
                    </v-icon>
                </template>

                <!-- <template v-slot:label="{ item }">
                    {{ typeof item.amountChanges == "number" ? item.amountChanges + " " : "" }}{{ item.key ?
            language.t('LayerSwitcher.' + item.key) : item.name }}
                </template> -->
                <template v-slot:label="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                {{ typeof item.amountChanges == "number" ? item.amountChanges + " " : "" }}
                                {{ item.key
                                    ? language.t('LayerSwitcher.' + item.key)
                                : item.name }}
                            </span>
                        </template>

                        {{ typeof item.amountChanges == "number" ? item.amountChanges + " " : "" }}
                        {{ item.key
                            ? language.t('LayerSwitcher.' + item.key)
                        : item.name }}
                    </v-tooltip>
                </template>


            </v-treeview>

            <v-list-item v-else>
                <v-list-item-title>{{ language.t('LayerSwitcher.noLayers') }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
export default {
    name: "LayerSwitcher",

    data() {
        return {
            layersWithNames: [],
            selectedLayers: [],
            selectedLayersForEdit: [],
            activeLayer: [],

            loading: false,
        };
    },
    components: {},
    props: {
        /* Map.vue reference */
        map: {
            required: true,
        },
        isDisabled: {
            required: false,
            default: false,
        },
        /* for civil there is the posibility to have an extra select box for some layers */
        selection: {
            required: false,
            default: false,
        },
        /* option to filter for only specific layers, used on the robot to filter for only dxf layers
                if filter is array: filter out top level layers that do not match
                if filter is string: only show child layers of this layer */
        filter: {
            required: false,
            default: null,
        },
        allnoneButtons: {
            required: false,
            default: true,
        },
    },
    computed: {},
    mounted: function () { },
    watch: {
        selectedLayers(val, oldval) {
            var added = val.filter((x) => !oldval.find((o) => o.id === x.id));
            added.forEach((item) => {
                item.show()
            });

            var removed = oldval.filter((x) => !val.find((o) => o.id === x.id));
            removed.forEach((item) => {
                // // Only hide if the layer also still exists in the list
                if (!this.layersWithNames.find((o) => o.id === item.id || o.children.some((oc) => oc.id === item.id))) return;

                // Do not hide a layergroup because we only hide the induvidual layers
                if (item.children.length == 0) item.hide();
            });
        },
        language(val) {
            console.log(val);
        },
        activeLayer(val) {
            console.log(val);
        }
    },
    methods: {
        setActiveLayer(id) {
            var layerT = this.selectedLayers.find(layer => layer.id == id)
            if (layerT) {
                this.activeLayer.push(layerT)
                this.$nextTick(() => {
                    this.$refs.layerselectorlist.$el.scrollTop = this.$refs.layerselectorlist.$el.getElementsByClassName('v-treeview-node--active').item(0).offsetTop
                });
            } else {
                this.activeLayer = [];
            }
        },
        selectAll() {
            this.selectedLayers = this.layersWithNames;
        },
        selectNone() {
            this.selectedLayers = [];
        },
        getLayersArray() {
            this.layersWithNames = [];
            this.selectedLayers = [];
            this.$nextTick(() => {
                var layersToAdd = [];
                this.map.map.mapElements.forEach(mapElement => {
                    var layers = mapElement.getLayers();
                    if (layers) {
                        layersToAdd.push(mapElement.getLayers());
                        layersToAdd = layersToAdd.flat(Infinity);
                    }
                })
                this.layersWithNames = layersToAdd;

                this.layersWithNames.forEach(layer => {
                })

                this.selectedLayers = this.getSelectedLayers(this.layersWithNames);
                // expand all items

                this.$nextTick(() => {
                    if (this.$refs.treeview) {
                        this.$refs.treeview.updateAll(true);
                    }
                });
            });
        },
        getSelectedLayers(layers, selectedLayers = []) {
            layers.forEach(layer => {
                if (layer.children && layer.children.length > 0) {
                    // if (layer.visible) selectedLayers.push(layer);
                    this.getSelectedLayers(layer.children, selectedLayers);
                } else {
                    if (layer.visible) selectedLayers.push(layer);
                }
            });
            return selectedLayers;
        },
        editButtonClick(item) {
            this.$emit("editLayer", item.id)
        }
    },
};
</script>

<style scoped>
.v-treeview-node__checkbox {
    font-size: xx-large !important;
}
</style>

<style>
#layerlist .v-treeview-node--active {
    background-color: #0099ff;
}
</style>